package com.example.mystybag.common.model

import androidx.compose.ui.text.input.TextFieldValue

data class DualTextInputBottomSheetUIState(
    val text1       : TextFieldValue = TextFieldValue(),
    val text2       : TextFieldValue = TextFieldValue(),
    val title       : String         = "",
    val hint1       : String         = "",
    val hint2       : String         = "",
    val buttonText  : String         = "",
    val isError     : Boolean        = false,
    val errorText   : String         = ""
)
